// src/Views/Activity.js

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import ScrambleText from '../Components/ScrambleText';
import './Activity.css';

const activities = [
  {
    title: 'Events Officer',
    organization: 'Science Society, University College Dublin',
    date: 'May 2025 – May 2026',
    summary: 'Responsible for planning and organising weekly events in collaboration with PR, design and sponsorship teams.',
    details: (
      <p>
        Hosting multiple events a week with my best friends and seeing it all come together is one of the most rewarding experiences I have had. I have learned how to work with different teams, manage my time and take responsibility for the success of events.
        Dealing with paperwork, room bookings and other boring tasks was a part of the job, but it taught me how to be organized and efficient. I have also learned how to work with different people and manage conflicts when they arise.
      </p>
    ),
  },
  {
    title: 'Peer Mentor',
    organization: 'University College Dublin',
    date: 'August 2025 – February 2026',
    summary: 'Guided new first-year undergraduate students around campus and assisted them with issues that they might have. We helped them with course registrations, finding friends and overall wellbeing.',
    details: (
      <p>
        The best part about being a peer mentor is learning to be a helpful guide to students of an incredibly diverse range of backgrounds. It was fun to show the unique aspects of UCD and making sure that students felt comfortable and supported in their new environment. I learned how to be patient, empathetic and understanding of different perspectives.
      </p>
    ),
  },
  {
    title: 'Sports Captain',
    organization: 'Greenwood High International School',
    date: 'January 2023 – January 2024',
    summary: 'Organized 10+ school events and was the Sports Executive Head for the school fest. I oversaw and managed the organisation, budgeting, and prizes for all inter-school sports competitions involving 1500 students.',
    details: (
      <p>
        We all had separate sets of friends before we were part of the student council. As we worked together to solve the school's problems and complete tasks assigned to us, we became one friend group. It was very fulfilling to be a part of the journey. I learnt that leadership is not just about making decisions, but also about supporting and empowering others.
      </p>
    ),
  },
    {
    title: 'Future Skills Program',
    organization: 'University College Dublin',
    date: 'January 2026 – April 2026',
    summary: 'Engaged in workshops to hone key skills for a good career including leadership, teamwork, active listening, technological literacy, creative and analytical thinking.',
    details: (
      <p>
        My bestie told me about this program and I didn’t think about it too much and just signed up. The workshops were fun where we'd work as a team to learn different skills. Yea, Everything else they taught, I already knew. 😐😐😐
      </p>
    ),
  },
      {
    title: 'Stem Cell Research Summer Training',
    organization: 'IIT Hyderabad (online)',
    date: 'May 2025 – July 2025',
    summary: 'Learned key skills about stem cells and how to conduct research. Produced a paper explaining the therapeutic applications of mesenchymal stem cells in regenerative medicine.',
    details: (
      <p>
        I learnt so many interesting things I never knew could happen. It opened so many doors for me to explore the field of stem cell research and regenerative medicine. This course showed me that this field is so vast and has so much potential for research and discovery. I am excited to explore this field further and see where it takes me.
      </p>
    ),
  },
      {
    title: 'Biological Sciences Practical Learning Programme',
    organization: 'iCrest Academy', 
    date: 'May 2023 – June 2023',
    summary: 'The program offered practical insights with 30 hands-on experiments in microbiology, biochemistry, bioinformatics, cell biology, and biotechnology.',
    details: (
      <p>
        I got to go to the lab every day for 6 weeks where we would have a theory class and then put everything we had learned into practice in the lab. Learning laboratory techniques and seeing professionals work in this environment were inspiring. We were often asked to make presentations on related innovative concepts, which made for a fun learning experience.
      </p>
    ),
  },
  {
      title: 'Shadowing Internships',
      organization: 'Hospitals in Bangalore',
      date: '2023–2025',
      summary:
        'Completed 230 hours of hospital shadowing across clinical, diagnostic, surgical, and patient-care departments.',
      details: (
        <div className="shadowing-list">
          <div className="shadowing-item">
            <div className="shadowing-item__header">
              <h3>Sakra World Hospital</h3>
              <span>July 2025</span>
            </div>
            <p>
              Completed an intensive 80-hour observership, gaining broad exposure
              to clinical practices and patient care pathways across departments
              including Laboratory Medicine, Emergency Medicine, Radiology &
              Imaging, Vascular & Interventional Radiology, Internal Medicine,
              Neurology, Cardiology, and OT-ENT.
            </p>
          </div>

          <div className="shadowing-item">
            <div className="shadowing-item__header">
              <h3>Medstar Speciality Hospital</h3>
              <span>June 2025</span>
            </div>
            <p>
              Participated in a 30-hour shadowing program spanning Internal
              Medicine, Radiology, Operation Theatre, and Clinical Laboratory
              departments. Observed diagnostic procedures, patient consultations,
              and minor clinical interventions such as excisions, ECG monitoring,
              and suturing.
            </p>
          </div>

          <div className="shadowing-item">
            <div className="shadowing-item__header">
              <h3>Aayug Multispecialty Hospital</h3>
              <span>2023</span>
            </div>
            <p>
              Shadowed doctors of different disciplines for a total of 120 hours.
              Witnessed out-patient and in-patient treatment and surgeries.
              Observed lab technicians perform biochemical analysis of blood and
              urine.
            </p>
          </div>
        </div>
      ),
    },
          {
    title: 'Horse Riding',
    organization: 'Flying Sea Stallion Riding School', 
    date: '2016 – Present',
    summary: 'An animal lover since childhood, I have ridden horses for over 10 years, represented my school in national-level competitions, and won several accolades. Training and caring for horses has also taught me responsibility and empathy.',
    details: (
      <p>
        One of my fondest memories was when I got a standing ovation from the crowd in Kolkata, India. I had fallen off the horse in my first attempt at the show jumping competition and injured my leg. I did the exact same routine again just 15 minutes later and set a new record for that course. I felt so proud of the horse and myself.
        The best thing that the entire experience of horse riding taught me is to expect the unexpected, and to make quick decisions under pressure. A horse's unpredictable nature meant that, as the rider, I needed to make quick decisions and remain calm under pressure.
      </p>
    ),
  },
];

const Activity = () => {
  const location = useLocation();
  const [activeActivity, setActiveActivity] = useState(null);

  useEffect(() => {
    if (!activeActivity) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [activeActivity]);

  useEffect(() => {
    const targetIndex = location.state?.fromHomeCard
      ? location.state.openItem
      : null;
    if (!Number.isInteger(targetIndex) || !activities[targetIndex]) return undefined;

    const timer = window.setTimeout(
      () => setActiveActivity(activities[targetIndex]),
      360
    );
    return () => window.clearTimeout(timer);
  }, [location.state]);

  return (
    <main className="activities-page">
      <section className="activities-hero">
        {/* <p className="activities-eyebrow">Beyond Work</p> */}
        <h1><ScrambleText text="Activities" /></h1>
        <p className="activities-intro">
          The things I choose to spend my time on outside of academics and work.
          Sports, leadership, internships, volunteering, hobbies, and the
          experiences that have shaped who I am.
        </p>
      </section>

      <section className="activities-list">
        {activities.map((activity) => (
          <article
            key={activity.title}
            className="activity-card"
            onClick={() => setActiveActivity(activity)}
          >
            <h2><ScrambleText text={activity.title} /></h2>

            {activity.organization && (
              <p className="activity-card__organization">
                @{activity.organization}
              </p>
            )}
            <p className="activity-card__date">{activity.date}</p>
            <p className="activity-card__summary">{activity.summary}</p>
            <span className="activity-card__desktop-cue" aria-hidden="true">
              Read more <span className="activity-card__desktop-arrow">↗</span>
            </span>
          </article>
        ))}
      </section>

      {activeActivity && createPortal(
        <div
          className="activity-modal-backdrop"
          onClick={() => setActiveActivity(null)}
        >
          <article
            className="activity-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="activity-modal__close"
              onClick={() => setActiveActivity(null)}
              aria-label="Close activity details"
            >
              ×
            </button>

            <p className="activity-modal__date">{activeActivity.date}</p>

            <h2><ScrambleText text={activeActivity.title} /></h2>

            {activeActivity.organization && (
              <p className="activity-modal__organization">
                @{activeActivity.organization}
              </p>
            )}  

            <p className="activity-modal__summary">
              {activeActivity.summary}
            </p>

            <div className="activity-modal__details">
              {activeActivity.details}
            </div>
          </article>
        </div>,
        document.body
      )}
    </main>
  );
};

//  {
//    title: '...',
//    organization: '...',
//    date: '202_  - 202_',
//    summary: '...',
//    details: (
//      <p>
//       ...      
//      </p>
//    ),
//  },

export default Activity;
